import {DatePicker as ArkDatePicker, useDatePickerContext} from '@ark-ui/react/date-picker'
import {Layout} from '~/components'
import {DatePickerViewNextTrigger, DatePickerViewPrevTrigger} from '../view_control'
import './index.less'

/**
 * @typedef {Object} DatePickerDayTableProps
 * @property {import('@ark-ui/react/date-picker').UseDatePickerContext} datePicker
 * @property {import('@ark-ui/react/date-picker').DateValue[][]} weeks
 * @property {{start: import('@ark-ui/react/date-picker').DateValue, end: import('@ark-ui/react/date-picker').DateValue}} [visibleRange]
 * Range used to determine which offset-month dates are visible.
 */

/** @param {DatePickerDayTableProps} props */
const DatePickerDayViewTable = ({datePicker, weeks, visibleRange}) => {
	return (
		<ArkDatePicker.Table>
			<ArkDatePicker.TableHead>
				<ArkDatePicker.TableRow>
					{datePicker.weekDays.map(weekDay => (
						<ArkDatePicker.TableHeader key={weekDay.short}>{weekDay.narrow}</ArkDatePicker.TableHeader>
					))}
				</ArkDatePicker.TableRow>
			</ArkDatePicker.TableHead>
			<ArkDatePicker.TableBody>
				{weeks.map((week, weekIndex) => (
					<ArkDatePicker.TableRow key={weekIndex}>
						{week.map(day => (
							<ArkDatePicker.TableCell key={day.toString()} value={day} visibleRange={visibleRange}>
								<ArkDatePicker.TableCellTrigger>{day.day}</ArkDatePicker.TableCellTrigger>
							</ArkDatePicker.TableCell>
						))}
					</ArkDatePicker.TableRow>
				))}
			</ArkDatePicker.TableBody>
		</ArkDatePicker.Table>
	)
}

export const DatePickerDayView = () => {
	return (
		<ArkDatePicker.View view="day">
			<ArkDatePicker.Context>
				{ctx => {
					const monthOffsets = Array.from({length: ctx.numOfMonths - 1}, (_, monthOffset) => ctx.getOffset({months: monthOffset + 1}))

					return (
						<Layout gap={12} direction="horizontal" vertical="top">
							<Layout direction="vertical">
								<DatePickerDayViewHeader title={ctx.visibleRangeText.start} showNextButton={monthOffsets.length === 0} showPrevButton />
								<DatePickerDayViewTable datePicker={ctx} weeks={ctx.weeks} visibleRange={ctx.visibleRange} />
							</Layout>
							{monthOffsets.map((offset, index) => (
								<Layout key={offset.visibleRange.start.toString()} direction="vertical">
									<DatePickerDayViewHeader title={offset.visibleRangeText.start} showNextButton={index === monthOffsets.length - 1} />
									<DatePickerDayViewTable datePicker={ctx} weeks={offset.weeks} visibleRange={offset.visibleRange} />
								</Layout>
							))}
						</Layout>
					)
				}}
			</ArkDatePicker.Context>
		</ArkDatePicker.View>
	)
}

const DatePickerDayViewHeader = ({title, showPrevButton, showNextButton}) => {
	const ctx = useDatePickerContext()

	return (
		<Layout data-part="navigation-header" width="full">
			<Layout horizontal="start">{showPrevButton && <DatePickerViewPrevTrigger />}</Layout>
			<ArkDatePicker.ViewTrigger>
				<Layout {...ctx.getRangeTextProps()}>{title}</Layout>
			</ArkDatePicker.ViewTrigger>
			<Layout horizontal="end">{showNextButton && <DatePickerViewNextTrigger />}</Layout>
		</Layout>
	)
}
